import $ from 'jquery';
import Swiper from 'swiper';
import { updateTreesCounter } from './donationToTrees';

const selectFormatElements = document.querySelectorAll('.calendar-page-choose-format');
const selectedCalendarFormatRadioElement = document.querySelector('.calendar-page-choose-format:checked');
const showPriceElement = document.querySelector('.js-show-price');
const showPriceElement2 = document.querySelector('.js-show-price-2');
let price;
let donation;
let availability;


const updateValues = function () {
  updateTreesCounter(donation);
  if(showPriceElement != null) {
    showPriceElement.textContent = price;
    showPriceElement.classList.remove('is-hidden');
  }

  if(showPriceElement2 != null) {
    showPriceElement2.textContent = price;
    showPriceElement2.classList.remove('is-hidden');
  }

  // quick and dirty solution, should be changed properly
  $(".format-stock-block").hide();
  $("#stock-a3-calendar").show();
};

const changeFormat = (event) => {
  ({ price, donation, availability } = event.currentTarget.dataset);
  if( availability == 1)
  {
    $(event.currentTarget).prop('checked', true);
    updateValues();
  }
  else
  {
    $(event.currentTarget).prop('checked', false);
    return false;
  }

  $(".format-stock-block").hide();
  $("#stock-" + event.currentTarget.id).show();


};

for (const selectFormatElement of selectFormatElements) {
  selectFormatElement.addEventListener('change', changeFormat);
}


window.onload = () => {

  ({ donation } = document.querySelector('.a3-calendar').dataset);
  updateTreesCounter(donation);

  ({ price, donation, availability } = selectedCalendarFormatRadioElement.dataset);
  updateValues();

  const mySwiper = new Swiper('.swiper-container');

  $(".swiper-button-prev").click(function() {
    mySwiper.slidePrev();
  })

  $(".swiper-button-next").click(function() {
    mySwiper.slideNext();
  })

  $('.js-slide-to').click(function () {
    const slide = $(this).data('slide');
    mySwiper.slideTo(slide);
  });

};

